import PropTypes from 'prop-types';
import { iconsList } from '../icon/glyphs';
import { SIZES, APPEARANCES } from './constants';

export const IconButtonProps = {
  icon: PropTypes.node,
  glyph: PropTypes.oneOf(iconsList),
  label: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZES)),
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  transparent: PropTypes.bool,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
};
